import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

// All feature routes below are scaffolding-only placeholder views (see
// CLAUDE.md "What NOT to do" -- real Browse/Update/viewer screens come later).
// They're real routed Vue components, not dead links, wired into
// AbstractProgramList.vue's sidebar nav.
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/deed-search',
  },
  {
    path: '/additions',
    name: 'Additions',
    component: () => import('../views/Additions.vue'),
  },
  {
    path: '/sub-additions',
    name: 'SubAdditions',
    component: () => import('../views/SubAdditions.vue'),
  },
  {
    path: '/deeds',
    name: 'Deeds',
    component: () => import('../views/Deeds.vue'),
  },
  {
    path: '/deed-search',
    name: 'DeedSearch',
    component: () => import('../views/DeedSearch.vue'),
  },
  {
    path: '/docs-images',
    name: 'DocsImages',
    component: () => import('../views/DocsImages.vue'),
  },
  {
    path: '/image-viewer',
    name: 'ImageViewerPage',
    component: () => import('../views/ImageViewerPage.vue'),
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Reports.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
  },
  {
    path: '/scheduled-jobs',
    name: 'ScheduledJobs',
    component: () => import('../views/ScheduledJobs.vue'),
  },
  {
    path: '/name-index',
    name: 'NameIndex',
    component: () => import('../views/NameIndex.vue'),
  },
  {
    path: '/real-estate-index',
    name: 'RealEstateIndex',
    component: () => import('../views/RealEstateIndex.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  const isLoggedIn = store.getters['auth/token/isLoggedIn'];
  if (to.name !== 'Login' && !isLoggedIn) {
    return { name: 'Login', query: { redirect: to.fullPath } };
  }
  if (to.name === 'Login' && isLoggedIn) {
    return { name: 'Home' };
  }
  return true;
});

export default router;
